<div>
  <i class="fa-fw"
    [ngClass]="icon"
  aria-hidden="true"></i>&nbsp;
  @if (keyTrad) {
    <span class="label"
      >{{ keyTrad | translate }}&nbsp;
    </span>
  }
  <span class="value">
    <ng-content></ng-content>
  </span>
</div>
